import { r, s } from '@/theme/tokens';
import type { SxProps, Theme } from './types';

export const tooltipOverlayFontSize = '13px';
export const tooltipOverlayTitleFontSize = tooltipOverlayFontSize;
export const tooltipOverlayMetaFontSize = tooltipOverlayFontSize;
export const tooltipOverlayLineHeight = 1.35;
export const tooltipOverlayCompactLineHeight = 1.25;
export const tooltipOverlayBodyFontWeight = 400;
export const tooltipOverlayLabelFontWeight = 500;
export const tooltipOverlayTitleFontWeight = 500;
export const tooltipOverlayMetricFontWeight = 500;
export const tooltipOverlayPaddingX = s('md');
export const tooltipOverlayPaddingY = s('sm');
export const tooltipOverlayCompactPaddingX = s('sm');
export const tooltipOverlayCompactPaddingY = s('sm');
export const tooltipOverlayRowGap = s('sm');
export const tooltipOverlayMicroGap = s('xs');
export const tooltipOverlayRadius = r('md');
export const tooltipOverlayCompactMaxWidth = '360px';
export const tooltipOverlayDataMaxWidth = '720px';
export const tooltipOverlaySurfaceColor = 'var(--tooltip-overlay-surface)';
export const tooltipOverlayBorderColor = 'var(--tooltip-overlay-border)';
export const tooltipOverlayTextColor = 'var(--tooltip-overlay-text)';

export const buildTooltipOverlaySurfaceSx = (theme: Theme): Record<string, string | number> => ({
  backgroundColor: tooltipOverlaySurfaceColor,
  backgroundImage: 'none',
  border: `1px solid ${tooltipOverlayBorderColor}`,
  borderRadius: tooltipOverlayRadius,
  boxShadow:
    theme.palette.mode === 'light'
      ? '0 8px 24px rgba(15, 23, 42, 0.14)'
      : '0 6px 18px rgba(0, 0, 0, 0.24)',
  color: tooltipOverlayTextColor,
});

export const tooltipOverlayBaseSx: SxProps<Theme> = (theme) => ({
  ...buildTooltipOverlaySurfaceSx(theme),
  fontSize: tooltipOverlayFontSize,
  fontWeight: tooltipOverlayBodyFontWeight,
  lineHeight: tooltipOverlayLineHeight,
  padding: `${tooltipOverlayPaddingY} ${tooltipOverlayPaddingX}`,
});

export const tooltipOverlayArrowSx: SxProps<Theme> = (_theme) => ({
  color: tooltipOverlaySurfaceColor,
  '&::before': {
    border: `1px solid ${tooltipOverlayBorderColor}`,
    boxSizing: 'border-box',
  },
});
